function formatTime(seconds)
{
    seconds = Math.floor(seconds);

    const minutes = Math.floor(seconds/60);
    const minutesStr = minutes.toString();
    const remainder = seconds - minutes*60;

    let secondsStr = remainder.toString();
    if (secondsStr.length === 1) {
        secondsStr = '0' + secondsStr;
    }

    return minutesStr + ':' + secondsStr;
}

export {formatTime};